module.exports = __webpack_public_path__ + "img/arrow-right.d74cdf06.svg";